export default __webpack_public_path__ + "static/media/github-select-actions.a7d02605.png";